import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IValidatePasswordUseCase {
    execute(
        authToken: string,
        apiKey: string,
        identityToken: string,
        epochMs: string,
        encPw: string,
        username: string
    ): Promise<any>;
}

export class ValidatePasswordUseCase implements IValidatePasswordUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        authToken: string,
        apiKey: string,
        identityToken: string,
        epochMs: string,
        encPw: string,
        username: string
    ): Promise<any> {
        const result = await this.profileRepository.validatePassword(
            authToken,
            apiKey,
            identityToken,
            epochMs,
            encPw,
            username
        );
        return result.data;
    }
}
